import type { PostParent } from '$lib/api/restApi';
import type { Post } from '$lib/api/rpc';
import { createEmptyPost, previewImages } from '$textEditor/PostComposer/composerStore';
import { writable, type Writable } from 'svelte/store';

export const widgetTypes = ['widgetQuickPoll', 'widgetLink', 'widgetHtml'] as const;
export type WidgetType = (typeof widgetTypes)[number];
export interface WidgetPost extends PostParent {
	etc: {
		widget: {
			html: string;
			url: string;
		};
	};
}

export const isWidget = (type: string) => {
	return widgetTypes.includes(type as WidgetType);
};

export const isWidgetModalOpen = writable(false);
export let widgetPost = writable(createEmptyPost(true) as WidgetPost);

export const openWidgetModal = (selectLink = false) => {
	const post = createEmptyPost(true) as WidgetPost;
	if (selectLink) {
		post.type = 'widgetLink';
	}
	widgetPost.set(post);
	isWidgetModalOpen.set(true);
};

export const editWidget = (postStore: Writable<Post>) => {
	widgetPost = postStore as unknown as Writable<WidgetPost>;
	isWidgetModalOpen.set(true);
};

export const addPreviewImages = (images: string[]) => {
	//TODO: This function is duplicated for the composer
	previewImages.update((prev) => [...prev, ...new Set(images)]);
	widgetPost.update((post) => {
		if (post.title_image.url) return post;
		return {
			...post,
			title_image: {
				...post.title_image,
				url: images[0],
			},
		};
	});
};
